// define all UI variable
const navToggler = document.querySelector('.nav-toggler');
const navMenu = document.querySelector('#mobile-menu');
const navLinks = document.querySelectorAll('#mobile-menu li a');

// load all event listners
allEventListners();

// functions of all event listners
function allEventListners() {
  // toggler icon click event
  navToggler.addEventListener('click', togglerClick);
}

// togglerClick function
function togglerClick() {
  // navToggler.classList.toggle('toggler-open');
  navMenu.classList.toggle('hidden');
  navMenu.classList.toggle('absolute');
}

document.addEventListener("scroll", function() {
  if (window.scrollY && window.scrollY > 1) {
    document.getElementById("mainNav").classList.add("bg-white");
  } else {
    document.getElementById("mainNav").classList.remove("bg-white");
  }
});


/* SWIPER */
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
Swiper.use([Navigation, Pagination]);
var swiper = new Swiper(".mySwiper", {
  slidesPerView: 1,
  spaceBetween: 30,
  slidesPerGroup: 1,
  loop: true,
  loopFillGroupWithBlank: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      slidesPerGroup: 2,
    },
    1024: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
  },
});